import { CreditCard, Truck, ShieldCheck, Lock } from "lucide-react";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { RadioGroup, RadioGroupItem } from "@/components/ui/radio-group";
import { Button } from "@/components/ui/button";
import { Separator } from "@/components/ui/separator";

export const CheckoutExpressPreview = ({ settings }: any) => (
    <div className="space-y-2">
        <div className="text-xs text-center text-gray-500 font-medium">Express Checkout</div>
        <div className="grid grid-cols-3 gap-2">
            <Button variant="outline" className="bg-[#F6C657] hover:bg-[#F6C657]/90 text-black border-none h-10">PayPal</Button>
            <Button variant="outline" className="bg-black hover:bg-black/90 text-white border-none h-10">GPay</Button>
            <Button variant="outline" className="bg-black hover:bg-black/90 text-white border-none h-10">Pay</Button>
        </div>
        <div className="relative flex items-center py-2">
            <div className="flex-grow border-t border-gray-200"></div>
            <span className="flex-shrink-0 mx-4 text-gray-400 text-xs">OR</span>
            <div className="flex-grow border-t border-gray-200"></div>
        </div>
    </div>
);

export const CheckoutShippingPreview = ({ settings }: any) => (
    <div className="space-y-4 p-4 border rounded-lg bg-white">
        <h3 className="font-semibold flex items-center gap-2">
            <Truck className="w-4 h-4" /> Shipping Information
        </h3>
        <div className="grid grid-cols-2 gap-3">
            <div className="col-span-2">
                <Label>Full Name</Label>
                <Input placeholder="John Doe" />
            </div>
            <div className="col-span-2">
                <Label>Address</Label>
                <Input placeholder="123 Main St" />
            </div>
            <div>
                <Label>City</Label>
                <Input placeholder="New York" />
            </div>
            <div>
                <Label>Zip Code</Label>
                <Input placeholder="10001" />
            </div>
        </div>
    </div>
);

export const CheckoutPaymentPreview = ({ settings }: any) => (
    <div className="space-y-4 p-4 border rounded-lg bg-white">
        <h3 className="font-semibold flex items-center gap-2">
            <CreditCard className="w-4 h-4" /> Payment Method
        </h3>
        <RadioGroup defaultValue="card">
            <div className="flex items-center space-x-2 border p-3 rounded-md">
                <RadioGroupItem value="card" id="card" />
                <Label htmlFor="card" className="flex-1 flex items-center justify-between cursor-pointer">
                    <span>Credit Card</span>
                    <div className="flex gap-1">
                        <div className="w-8 h-5 bg-gray-100 rounded"></div>
                        <div className="w-8 h-5 bg-gray-100 rounded"></div>
                    </div>
                </Label>
            </div>
            <div className="flex items-center space-x-2 border p-3 rounded-md">
                <RadioGroupItem value="cod" id="cod" />
                <Label htmlFor="cod" className="cursor-pointer">Cash on Delivery</Label>
            </div>
        </RadioGroup>

        <div className="bg-gray-50 p-3 rounded text-xs text-gray-500 flex items-center gap-2">
            <Lock className="w-3 h-3" />
            Payments are secure and encrypted.
        </div>
    </div>
);

export const CheckoutSummaryPreview = ({ settings }: any) => (
    <div className="bg-gray-50 p-4 rounded-lg space-y-4">
        <h3 className="font-semibold">Order Summary</h3>
        <div className="space-y-3">
            <div className="flex gap-3">
                <div className="w-16 h-16 bg-white rounded border flex items-center justify-center relative">
                    <span className="text-2xl">👟</span>
                    <span className="absolute -top-2 -right-2 bg-gray-500 text-white text-xs w-5 h-5 rounded-full flex items-center justify-center">1</span>
                </div>
                <div className="flex-1">
                    <div className="text-sm font-medium">Awesome Sneakers</div>
                    <div className="text-xs text-gray-500">Size: 42</div>
                </div>
                <div className="text-sm font-medium">$49.99</div>
            </div>
        </div>
        <Separator />
        <div className="space-y-1 text-sm">
            <div className="flex justify-between">
                <span className="text-gray-500">Subtotal</span>
                <span>$49.99</span>
            </div>
            <div className="flex justify-between">
                <span className="text-gray-500">Shipping</span>
                <span>Free</span>
            </div>
        </div>
        <Separator />
        <div className="flex justify-between font-bold text-lg">
            <span>Total</span>
            <span>$49.99</span>
        </div>
    </div>
);

export const OrderBumpPreview = ({ settings }: any) => (
    <div className="border-2 border-dashed border-primary/30 bg-primary/5 p-4 rounded-lg flex gap-3 items-start">
        <input type="checkbox" className="mt-1 w-4 h-4" />
        <div>
            <div className="font-bold text-sm text-primary">
                Yes! Add {settings.title || "Special Offer"} - {settings.price || "$19.99"}
            </div>
            <p className="text-xs text-gray-600 mt-1">
                One time offer! Get this amazing add-on for a special price. Usually sold for much more.
            </p>
        </div>
    </div>
);
